export default {
  computed: {
    allLogs: function () {
      return this.$store.state.LogStore.all_logs
    },
    allChangeLogs: function () {

      return this.$store.state.LogStore.change_logs
    },
    authLogs: function () {
      return this.$store.state.LogStore.auth_logs
    },
    featureLogs: function () {
      return this.$store.state.LogStore.feature_logs
    },
    passwordResetsLogs: function () {
      return this.$store.state.LogStore.password_resets_logs
    },
    mpesaTransactions: function () {
      return this.$store.state.PaymentMethodStore.mpesa_transactions
    },
    singleLatestVersion: function () {
      if (this.$store.state.LogStore.single_change_log.version== undefined){
          return
      }else{
        return this.$store.state.LogStore.single_change_log.version
      }
      
      
    }
  }
}
